import { styled } from '@mui/material';
import WelcomePageBg from 'assets/img/login-page.jpg';
import { BodySmallRegular } from 'v3/shared/typography/BodySmall';
import { theme } from 'v3/styles/global-styles';

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  color: theme.palette.common.white,
  flexGrow: 1,

  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
  },
}));

export const LogoImgStyled = styled('img')(() => ({
  width: '10.5rem',
  marginTop: '1.5rem',
}));

export const AlignTextHeader = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',

  [theme.breakpoints.up('md')]: {
    width: '50%',
  },
}));

export const Header = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  backgroundImage: `url(${WelcomePageBg})`,
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  padding: '1rem 2rem',
  width: '100%',
  flexGrow: 1,

  [theme.breakpoints.up('md')]: {
    padding: '1rem 5%',
  },
}));

export const MainTitle = styled('div')(() => ({}));

export const Aside = styled('aside')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: '2rem 2rem',
  backgroundImage: theme.palette.gradient[600],
  flexGrow: 1,
  gap: '2rem',

  [theme.breakpoints.up('md')]: {
    width: '50%',
  },

  [theme.breakpoints.up('xl')]: {
    padding: '0rem 5%',
    width: '40%',
  },
}));

export const AligItems = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  padding: '0rem 1rem',
  gap: '1rem',

  [theme.breakpoints.up('md')]: {
    padding: '0rem',
  },
}));

export const IconStyles = {
  width: '1.75rem',
  color: theme.palette.tertiary.main,
};

export const BodyMediumRegularStyled = styled(BodySmallRegular)(() => ({
  opacity: '0.6',
  marginTop: '0.5rem',
}));

export const TextAlign = styled('div')(() => ({
  padding: '0 1rem',
}));
